// @flow
import React, { Component, lazy, Suspense } from "react";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";

import { LoadingProgress } from "imagus-components";
const FacebaseItem = lazy((): * => import("../../containers/facebases/FacebaseAdminItemRedux"));

type FacebaseListStatesType = {
  expanded: null | boolean
};

type FacebaseListPropsType = {
  facebases: { [key: string]: * },
  setActionError: Function,
  openSnackbar: Function
};

class FacebaseList extends Component<FacebaseListPropsType, FacebaseListStatesType> {
  constructor(props: FacebaseListPropsType) {
    super(props);
    this.state = {
      expanded: null
    };
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render(): * {
    const { expanded } = this.state;
    const facebases = this.props.facebases;
    let list = [];
    for (let uuid in facebases) {
      let facebase = facebases[uuid];
      list.push(
        <ExpansionPanel expanded={expanded === uuid} onChange={this.handleChange(uuid)} key={uuid}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" className="heading">{facebase.name}</Typography>
            <Typography variant="subtitle1" className="subheading">{facebase.uuid}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Suspense fallback={<LoadingProgress />}>
              <FacebaseItem
                facebases={facebases}
                facebaseId={uuid}
                expanded={expanded === uuid}
                setActionError={this.props.setActionError}
                openSnackbar={this.props.openSnackbar}
              />
            </Suspense>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      );
    }

    return (
      <div className="app-panel-content panel-top-margin" >
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {list}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default FacebaseList;
